import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobDeploymentComponent } from './job-deployment.component';
import { QueueAutoDirectButtonComponent } from '../auto-direct/queue-auto-direct-button.component';

const routes: Routes = [
  { path: '', component: JobDeploymentComponent, data: { title: 'Job Deployment' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobDeploymentRoutingModule {}

@NgModule({
  imports: [
    JobDeploymentRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    QueueAutoDirectButtonComponent,
  ],
  declarations: [JobDeploymentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobDeploymentModule {}
